import React, { useCallback, useContext, useEffect, Fragment, useState } from "react";
import { Forms } from "../../components/backgrounds/Forms";
import { Primary } from "../../components/buttons/Primary";
import { Danger } from "../../components/buttons/Danger";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { RadioGroup } from "@headlessui/react";
import { Steps, titles } from "../../components/buttons/Steps";
import Numeral from "../../components/numeral/Numeral";
import { HttpRequest } from "../../services/httpRequest";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { FormOneContext } from "../../context/FormOne/FormOneContext";
import { FormTwoContext } from "../../context/FormTwo/FormTwoContext";
import { useNavigate } from "react-router-dom";
import { getInterest } from "../../utils/creditUser/getInterest";

const cupoPreAprobado = 200000;
const DIAS_REFERENCIA = 28;
const numberQuotas = [
  {
    id: 1,
    value: 1,
  },
  {
    id: 2,
    value: 3,
  },
];

const admon = 60000;
const iva = Math.round(admon * (19 / 100));

const calcularTotal = (ted) => {
  const tasaDecimal = ted ? parseFloat(ted) / 100 : 0;
  const interest = Math.round(cupoPreAprobado * tasaDecimal * DIAS_REFERENCIA);
  return { interest, total: Math.round(cupoPreAprobado + interest + admon + iva) };
};

const payload = {};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export function PreaprobadoPage() {
  const { formOne } = useContext(FormOneContext);
  const { formTwo } = useContext(FormTwoContext);
  const navigate = useNavigate();
  const { updateCreditUser, creditUser } = useContext(CreditUserContext);

  // Tasa dinámica: inicializar desde caché, actualizar al montar
  const cachedTed = localStorage.getItem("currentInterestRate");
  const { interest: interestInit, total: totalInit } = calcularTotal(cachedTed);
  const [interest, setInterest] = useState(interestInit);
  const [total, setTotal] = useState(totalInit);

  const [valuQuotas, setValuQuotas] = useState(totalInit);
  const [isLoading, setIsLoading] = useState(true);
  const [viewSpinner, setViewSpinner] = useState(false);
  const [dataUser, setDataUser] = useState("");
  const doc = localStorage.getItem("doc");
  const [selectedMailingLists, setSelectedMailingLists] = useState(
    numberQuotas[0]
  );

  const getCreditUser = async () => {
    try {
      const { message } = await HttpRequest.getCreditUser(doc);
      return message;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const handleSpinner = (isView) => {
    setViewSpinner(isView);
  };

  const loadInfoUser = useCallback(async () => {
    try {
      const data = await HttpRequest.getUserAuth(doc);
      setDataUser(data.message.user);
    } catch (error) {
      console.log(error);
    }
  }, [doc]);

  const handleSubmit = async () => {
    if (selectedMailingLists.id === 1) {
      const newTotal = Math.round(cupoPreAprobado + interest * 3 + admon * 3 + iva * 3);
      setTotal(newTotal);
      setValuQuotas(newTotal / 3);
    } else if (selectedMailingLists.id === 2) {
      const newTotal = Math.round(cupoPreAprobado + interest + admon + iva);
      setTotal(newTotal);
      setValuQuotas(newTotal);
    }
  };

  const sendData = async () => {
    if (selectedMailingLists.id === 1) {
      handleSpinner(true);
      let coords = localStorage.getItem("coords");

      Object.assign(
        payload,
        {
          formOne,
          formTwo,
          doc: creditUser.documento || localStorage.getItem("doc"),
          coords: JSON.parse(coords),
        }
      );
      const responseService = await HttpRequest.sendPayloadFormsExperian(payload);
      //const responseService = await HttpRequest.sendPayloadFormsUflow(payload);

      if (responseService.error) {
        if (responseService.message.errorCode === 506) {
          return navigate("/error");
        }
        handleSpinner(false);
        return navigate("/negado");
      }

      if (responseService.message.message === "APRUEBA") {
        const { info } = await getCreditUser();
        if (info) {
          updateCreditUser({
            credit_id: info.credit_id,
            approvedQuota: info.approvedQuota || cupoPreAprobado,
            termInDays: info.termInDays,
            totalToPay: info.totalToPay,
            paydayLimit: info.paydayLimit,
            documento: info.documento,
            acceptanceDate: info.acceptanceDate,
            approvedDate: info.approvedDate,
            status: info.status,
          });
          localStorage.setItem("credit_id", info.credit_id);
        }
        return navigate("/request-credit?renovar=true");
      }
    } else if (selectedMailingLists.id === 2) {
      handleSpinner(true);
      Object.assign(
        payload,
        {
          documento: dataUser.doc || localStorage.getItem("doc"),
          fullname: `${formOne.firstname} ${formOne.firstlastname}`,
          email: dataUser.email,
          phone: dataUser.phone,
          causaRestriccion: "Usuario selecciona metodo de pago a más de una cuota."
        }
      );
      const responseService = await HttpRequest.restrictionListUflow(payload);
      if (responseService.message.success === true) {
        handleSpinner(false);
        return navigate("/negado");
      } else if (responseService.message.success === false) {
        return navigate("/error");
      }
    }
  };

  useEffect(() => {
    setSelectedMailingLists(numberQuotas[0]);
    loadInfoUser();
    setIsLoading(false);
    // Obtener tasa del mes actual y recalcular
    getInterest().then(ted => {
      if (ted) {
        const { interest: i, total: t } = calcularTotal(ted);
        setInterest(i);
        setTotal(t);
        setValuQuotas(t);
      }
    }).catch(console.error);
  }, [loadInfoUser]);

  if (isLoading) {
    return (
      <Fragment>
        <div className="bg-red/10">
          <Steps
            estado1="complete"
            estado2="current"
            estado3="upcoming"
            estado4="upcoming"
          />
          <Forms
            title={titles[1].name}
            description={"Cargando la información."}
            form={
              <form action="#" method="POST">
                <div className="shadow-lg overflow-hidden rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="my-8"></div>
                  </div>
                </div>
              </form>
            }
          />
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="bg-red/10">
        <Steps
          estado1="complete"
          estado2="complete"
          estado3="current"
          estado4="upcoming"
        />
        <Forms
          isSpinner={viewSpinner}
          title={
            <div>
              <span>
                ¡Felicidades, tienes un cupo pre-aprobado de {"  "}
                <Numeral format={"$0,0"} value={cupoPreAprobado} />!
              </span>
            </div>
          }
          description={
            <div>
              <span></span>
            </div>
          }
          form={
            <form action="#" method="POST" onSubmit={sendData}>
              <div className="shadow-lg overflow-hidden rounded-md">
                <div className="px-4 py-5 bg-white sm:p-6">
                  <div className="text-center pb-14 text-xl font-bold uppercase">
                    Confirma el número de cuotas de tu crédito
                  </div>
                  <div className="grid grid-cols-6 gap-4">
                    <div className="col-span-8 lg:col-span-2 pb-4">
                      <div className="pb-0 lg:pb-8">
                        <span className="font-bold">Cupo pre-aprobado</span>
                        <p className="hidden md:block text-sm">
                          Este es tu cupo de crédito que tienes pre-aprobado
                        </p>
                      </div>
                      <Numeral
                        className="text-2xl font-bold"
                        format={"$0,0"}
                        value={cupoPreAprobado}
                      />
                    </div>
                    <div className="col-span-8 text-center lg:col-span-2 pb-4">
                      <div className="pb-0 lg:pb-8">
                        <span className="font-bold">Número de cuotas</span>
                        <p className="hidden md:block text-sm">
                          Este es el número de cuotas al que puedes diferir tu
                          crédito.
                        </p>
                      </div>
                      <RadioGroup
                        value={selectedMailingLists}
                        onChange={setSelectedMailingLists}
                      >
                        <div className="mt-1 grid gap-y-6 grid-cols-2 gap-x-4">
                          {numberQuotas.map((numberQuotas) => (
                            <RadioGroup.Option
                              onClick={handleSubmit}
                              value={numberQuotas}
                              key={numberQuotas.id}
                              className={({ checked, active }) =>
                                classNames(
                                  checked
                                    ? "border-transparent"
                                    : "border-purple/20 text-center",
                                  active
                                    ? "border-purple ring-1 ring-purple"
                                    : "",
                                  "relative bg-white border rounded-lg shadow-xs px-5 py-1 h-10 text-center focus:outline-hidden"
                                )
                              }
                            >
                              {({ checked, active }) => (
                                <>
                                  <span className="block">
                                    <div
                                      className="flex"
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span className="text-center">
                                        <RadioGroup.Description
                                          as="span"
                                          className="text-center font-medium text-xl cursor-pointer"
                                        >
                                          {numberQuotas.value}{" "}
                                          {/* Fecha limite de pago */}
                                        </RadioGroup.Description>
                                      </span>
                                      <CheckCircleIcon
                                        className={classNames(
                                          !checked ? "invisible" : "",
                                          "h-5 w-5 text-purple"
                                        )}
                                        aria-hidden="true"
                                      />
                                    </div>
                                  </span>
                                  <span
                                    className={classNames(
                                      active ? "border" : "border-2",
                                      checked
                                        ? "border-purple"
                                        : "border-transparent",
                                      "absolute -inset-px rounded-lg pointer-events-none"
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>
                    <div className="col-span-8 text-center lg:col-span-2">
                      <div className="pb-8">
                        <span className="font-bold block">
                          Fecha primera cuota
                        </span>
                        <span className="text-2xl font-bold">
                          {creditUser.paydayLimit}
                        </span>
                      </div>
                      <div className="pb-8">
                        <span className="font-bold block">
                          {selectedMailingLists.id === 1
                            ? `${selectedMailingLists.value} cuota mensual de`
                            : `${selectedMailingLists.value} cuotas mensuales de`}
                        </span>
                        <Numeral
                          className="text-2xl font-bold"
                          format={"$0,0"}
                          value={valuQuotas}
                        />
                      </div>
                    </div>
                    <div className="col-span-8 text-center">
                      <div className="pb-8">
                        <span className="font-bold block">Total a pagar</span>
                        <Numeral
                          className="text-2xl font-bold"
                          format={"$0,0"}
                          value={total}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex px-4 py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                    <div className="md:w-56 pr-2">
                      <Danger text="Rechazar" />
                    </div>
                    <div className="md:w-56">
                      <Primary text="Aceptar oferta" />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          }
        />
      </div>
    </Fragment>
  );
}
